import React, { useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import Services from "../../Services";
import DynamicInput from "../InputComponents/DynamicInput";

const { hr } = Services;

const EmployeeIdModal = ({ ModalData }) => {
  let { employeeDetails, setMainFlag, mainFlag, open, close } = ModalData;
  const theme = useTheme();

  const [updateUid, setupdateUid] = useState(employeeDetails?.uid);

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const onChangeUidValue = (value) => {
    setupdateUid(value);
  };
  let fields = [
    {
      type: 1,
      name: "Employee Uid",
      initial: updateUid,
      isRequired: true,
      onChange: onChangeUidValue,
    },
  ];

  function onUpdateUid(e) {
    e.preventDefault();

    let data = {
      id: employeeDetails.id,
      uid: updateUid,
    };

     
    try {
      hr.onUpdateUID(data)
        .then((certificateData) => {
          setMainFlag(!mainFlag);
          close(false);
        })
        .catch((err) => {
           
        });
    } catch (exc) {
       
    }
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => close(false)}
      className="BroadcastMessageModal LiqTables"
      aria-labelledby="responsive-dialog-title"
    >
      <Button
        autoFocus
        onClick={() => close(false)}
        className="ModalClose"
      ></Button>

      <form onSubmit={onUpdateUid}>
        <DialogContent>
          <DynamicInput fields={fields} />
          <Grid xs={12} container justifyContent="center" className="mt30">
            <Button type="submit" className="LinkButton">
              Save
            </Button>
          </Grid>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default EmployeeIdModal;
